var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[("badge-indicator " + _vm.size), _vm.value < 0 ? 'decline' : 'profit']},[_c('v-icon',{attrs:{"src":"arrow-down"}}),_c('small',[_vm._v(_vm._s(_vm.value)+"%")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }